import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { PrivacyPolicySheetComponent } from './privacy-policy-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    CsIconModule,
    FormsModule,
  ],
  declarations: [PrivacyPolicySheetComponent],
  exports: [PrivacyPolicySheetComponent],
})
export class PrivacyPolicySheetModule { }
